import { NavLink, useNavigate } from 'react-router-dom';
import { useSesion } from '../estado/SesionContext';

const ENLACES = [
  { a: '/', texto: 'Inicio', corto: 'Inicio', icono: '🏠', exacto: true },
  { a: '/modulos', texto: 'Módulos de aprendizaje', corto: 'Módulos', icono: '📚', exacto: false },
  { a: '/quizzes', texto: 'Quizzes', corto: 'Quizzes', icono: '📝', exacto: false },
  { a: '/recompensas', texto: 'Recompensas', corto: 'Premios', icono: '🎁', exacto: false },
];

/**
 * En escritorio es una barra superior con navegación al centro. En celular la navegación
 * baja a una barra fija abajo, donde el pulgar llega: los recursos usan esto de pie en
 * una tienda, no sentados.
 */
export function Cabecera() {
  const { perfil, puntos, espacio, salir } = useSesion();
  const navegar = useNavigate();

  async function alSalir() {
    await salir();
    navegar('/entrar', { replace: true });
  }

  return (
    <>
      <header className="sticky top-0 z-50 flex h-16 items-center gap-3 border-b-4 border-rojo bg-white px-4 shadow-[0_4px_18px_rgba(30,63,148,.10)] sm:px-6">
        <img src={espacio.logoUrl} alt={espacio.cliente} className="h-9 w-auto" />
        <span className="hidden font-titulos text-lg font-extrabold leading-none text-azul sm:block">
          Academia
        </span>

        <nav className="ml-4 hidden gap-1.5 lg:flex">
          {ENLACES.map((e) => (
            <NavLink
              key={e.a}
              to={e.a}
              end={e.exacto}
              className={({ isActive }) =>
                `rounded-full px-3 py-2 text-[0.8rem] font-extrabold transition lg:px-4 lg:text-sm ${
                  isActive ? 'bg-rojo text-white' : 'bg-cielo text-azul hover:brightness-95'
                }`
              }
            >
              {e.texto}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2 sm:gap-3">
          <div className="rounded-full bg-azul px-3 py-1.5 text-xs font-extrabold text-white sm:text-sm">
            ⭐ <span className="text-[#FFD9A8]">{puntos}</span> pts
          </div>
          <div
            className="flex h-9 w-9 items-center justify-center rounded-full bg-rojo text-sm font-extrabold text-white"
            title={`${perfil?.nombres ?? ''} ${perfil?.apellidos ?? ''}`.trim()}
          >
            {perfil?.iniciales}
          </div>
          <button
            onClick={alSalir}
            className="hidden rounded-full border-[1.5px] border-borde px-3 py-1.5 text-sm text-gris hover:bg-cielo sm:block"
          >
            Salir
          </button>
        </div>
      </header>

      {/* Barra inferior solo en celular. */}
      <nav className="fixed bottom-0 left-0 right-0 z-50 flex border-t border-borde bg-white pb-[env(safe-area-inset-bottom)] md:hidden">
        {ENLACES.map((e) => (
          <NavLink
            key={e.a}
            to={e.a}
            end={e.exacto}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-extrabold ${
                isActive ? 'text-rojo' : 'text-gris'
              }`
            }
          >
            <span className="text-lg leading-none">{e.icono}</span>
            {e.corto}
          </NavLink>
        ))}
        <button
          onClick={alSalir}
          className="flex flex-1 flex-col items-center gap-0.5 py-2 text-[11px] font-extrabold text-gris"
        >
          <span className="text-lg leading-none">🚪</span>
          Salir
        </button>
      </nav>
    </>
  );
}
